import { useEffect } from 'react'
import { useCartFeedback } from 'src/components/contexts/CartFeedbackContext'
import { useModalSheet } from 'src/components/contexts/ModalSheetContext'
import { useCheckout } from 'src/sdk/checkout/useCheckout'

import CartFeedbackContent from './CartFeedbackContent'

import './cart-feedback.scss'

const CartFeedback = () => {
  const { closeCartFeedback, showCartFeedback } = useCartFeedback()
  const { openModal, isModalOpen } = useModalSheet()
  const { isLoading } = useCheckout()

  useEffect(() => {
    if (showCartFeedback && !isModalOpen && !isLoading) {
      openModal({
        content: <CartFeedbackContent />,
        onClose: closeCartFeedback,
        width: '360px',
        height: 'auto',
      })
    }
  }, [closeCartFeedback, isModalOpen, openModal, showCartFeedback, isLoading])

  return null
}

export default CartFeedback
